import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { WorderService } from './shader/service/worder.service';

 export let browserRefresh=false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit,OnInit {
  subscription:Subscription;
  progress = 0;
  loading = false;
  constructor(public router: Router,private worderService: WorderService) {
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !router.navigated;
        var x =localStorage.getItem('userId');
        var y=this.worderService.loginpersonnel;
        // try{
        //   if(localStorage.getItem('userId')!=this.worderService.loginpersonnel){
        //     this.worderService.allowUvt=false;
        //     alert("Oturum bilgileriniz güncel değil, lütfen yeniden giriş yapınız!");
        //     this.router.navigate(['/login']);
        //     return;
        //   }   
        // }
        // catch(e){
        // }   
      }
    });
  }

  ngOnInit() {  
   
  }
  ngAfterViewInit(): void {
    
  }
  title = 'uvt card-container';


 
}
